// extracted by mini-css-extract-plugin
export default {"container":"BSecondaryNewsCard-module_container_e527feee","lazyImg":"BSecondaryNewsCard-module_lazyImg_eb17573d"};